export const SetAvailability = {
    Title: 'Set Availability'
}



// WEBPACK FOOTER //
// ./src/localization/SetAvailability.ts